// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nWAa","title":"styles_title__11x9N"};